import { Box, FormControl, MenuItem, Select } from "@common-ui/ui";
import React, { useEffect } from "react";
import { StatusChip } from "./StatusChip";
// import { workItemsSlice } from "../../reducers/workItemsReducer";
import { useSelector } from "react-redux";
import { updateWorkItem } from "../../services";

export const SummaryResult = ({
  id,
  work_event,
  performing_org,
  params,
  row,
}) => {
  const isDraft = params?.row?.status === "DRAFT" || row?.status === "DRAFT";
  const isCompleted =
    params?.row?.status === "COMPLETED" || row?.status === "COMPLETED";
  const workItem = useSelector((state) => state?.workItems[id]);
  const [result, setResult] = React.useState(
    workItem?.procedure_result_code
      ? workItem?.procedure_result_code
      : "DEFAULT"
  );
  const handleChange = (event) => {
    setResult(event.target.value);
    handleSubmit(event.target.value);

    //  "procedure_done": false,
    //"procedure_result_code": "string",
  };
  async function handleSubmit(procedure_result_code) {
    await updateWorkItem(
      { procedure_result_code },
      work_event,
      id,
      performing_org
    );
  }
  useEffect(() => {
    const status = workItem?.procedure?.status;
    let failCount = 0;
    let completedCount = 0;
    let passCount = 0;
    let skipCount = 0;
    let warnCount = 0;
    let newStatus = "";
    for (let i = 0; i < status?.steps?.length; i++) {
      if (status?.steps[i]["status"] === "COMPLETED") {
        completedCount += 1;
      }
      if (status?.steps[i]["result_code"] === "FAIL") {
        failCount += 1;
      }
      if (status?.steps[i]["result_code"] === "PASS") {
        passCount += 1;
      }
      if (status?.steps[i]["result_code"] === "SKIPPED") {
        skipCount += 1;
      }
      if (status?.steps[i]["result_code"] === "WARN") {
        warnCount += 1;
      }
    }

    let result = {
      [passCount]: "PASS",
      [failCount]: "FAIL",
      [skipCount]: "SKIPPED",
      [warnCount]: "WARN",
    };
    let max = Math.max(passCount, failCount, skipCount, warnCount);

    // console.log("newStatus", newStatus, result, max);

    if (completedCount > 0 && completedCount === status?.steps?.length) {
      newStatus = result[max];
      // if (failCount > 0) {
      //   newStatus = "FAIL";
      // } else {
      //   newStatus = "PASS";
      // }
    }
    if (!workItem?.procedure_result_code && completedCount > 0) {
      setResult(newStatus);
      handleSubmit(newStatus);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(workItem?.procedure?.status)]);
  return isDraft ? (
    <StatusChip status={result} />
  ) : isCompleted ? (
    <StatusChip status={result} />
  ) : (
    <Box>
      {result ? (
        <FormControl variant="standard" size="small">
          <Select
            disableUnderline={true}
            labelId="demo-select-small"
            id="demo-select-small"
            // value={"PASS"}
            defaultValue={result}
            onChange={handleChange}
            renderValue={() => <StatusChip status={result} />}
          >
            <MenuItem value={"PASS"}>Pass</MenuItem>
            <MenuItem value={"FAIL"}>Fail</MenuItem>
            <MenuItem value={"WARN"}>Warn</MenuItem>
            <MenuItem value={"SKIPPED"}>Skip</MenuItem>
            {/* <MenuItem value={"DEFAULT"}>Default</MenuItem> */}
          </Select>
        </FormControl>
      ) : (
        ""
      )}
    </Box>
  );
};
